export default __webpack_public_path__ + "static/media/asnx.91319aa0.svg";